module.exports = __webpack_public_path__ + "static/media/tutorial-banner.8c35b2b9.png";